<div class="flow-root flex-1 min-h-0 overflow-hidden w-full h-full">
    <div class="overflow-x-auto h-full">
        <div class="w-full h-full">
            <div class="data-table-wrapper h-full flex flex-col overflow-hidden">
                <div
                    class="flex w-full shrink-0 items-center justify-between gap-x-3 border-b border-[var(--border)] bg-[var(--muted)] px-3 py-2">
                    <div class="flex items-center gap-x-4 min-w-0 flex-1">
                        <div class="shrink-0 flex flex-col justify-center gap-0.5 max-w-[min(100%,18rem)] sm:max-w-[22rem]">
                            <h2 id="bttv2-ad-groups-table-heading"
                                class="text-sm font-semibold text-primary leading-snug">
                                Campaign ad groups
                            </h2>
                            <p class="text-xs text-secondary leading-snug">
                                These rows are the ad groups for the selected campaign.
                            </p>
                        </div>
                        <div class="grid grid-cols-1 w-1/5 min-w-[12rem] flex-1 max-w-md">
                            <label class="sr-only" for="bttv2-ad-groups-keyword-search">Search ad groups</label>
                            <input id="bttv2-ad-groups-keyword-search" type="search" name="ad-group-search"
                                placeholder="Keyword Search.." (input)="onSearch($event)"
                                class="col-start-1 row-start-1 block w-full py-1.5 pr-3 pl-10 input-primary-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" aria-hidden="true"
                                class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-secondary sm:size-4">
                                <path d="m21 21-4.34-4.34" />
                                <circle cx="11" cy="11" r="8" />
                            </svg>
                        </div>
                    </div>

                    <div class="flex flex-row gap-x-2 items-center justify-end shrink-0">

                        <button type="button" (click)="goToAdGroupCreate()"
                            class="inline-flex items-center gap-x-1.5 btn-shout btn-shout-xs btn-shout-primary">
                            Create Ad-Group
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="-mr-0.5 size-5">
                                <path d="M5 12h14" />
                                <path d="M12 5v14" />
                            </svg>
                        </button>

                        <bttv2-spark-ad-group-column-picker [visibleColumns]="visibleColumns()"
                            (columnsChange)="onColumnsChange($event)">
                        </bttv2-spark-ad-group-column-picker>
                    </div>
                </div>
                <div class="overflow-auto flex-1 min-h-0 scrollbar-transparent dark:bg-gray-800/50">
                    <div class="w-max min-w-full">
                        <table class="data-table min-w-full" aria-labelledby="bttv2-ad-groups-table-heading">
                            <thead class="sticky top-0 z-10">
                                <tr>
                                    <th scope="col"
                                        class="sticky left-0 z-20 w-28 min-w-28 max-w-28 bg-[var(--muted)] border-r border-[var(--border)] text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Enabled</th>
                                    <th scope="col"
                                        class="sticky left-28 z-20 min-w-[12rem] bg-[var(--muted)] border-r border-[var(--border)] text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Name</th>
                                    @if (isVisible('status')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Status</th>
                                    }
                                    @if (isVisible('time_created')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Time Created</th>
                                    }
                                    @if (isVisible('budget')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Budget</th>
                                    }
                                    @if (isVisible('scheduling')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Scheduling</th>
                                    }
                                    @if (isVisible('optimization_goal')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Optimization Goal</th>
                                    }
                                    @if (isVisible('billing_event')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Billing Event</th>
                                    }
                                    @if (isVisible('bid_type')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Bid Type</th>
                                    }
                                    @if (isVisible('bid_price')) {
                                    <th scope="col"
                                        class="text-right text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Bid Price</th>
                                    }
                                    @if (isVisible('pacing')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Pacing</th>
                                    }
                                    @if (isVisible('placements')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Placements</th>
                                    }
                                    @if (isVisible('gender')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Gender</th>
                                    }
                                    @if (isVisible('age_groups')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Age Groups</th>
                                    }
                                    @if (isVisible('location_ids')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Location IDs</th>
                                    }
                                    @if (isVisible('languages')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Languages</th>
                                    }
                                    @if (isVisible('promotion_type')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Promotion Type</th>
                                    }
                                    @if (isVisible('feed_type')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Feed Type</th>
                                    }
                                    @if (isVisible('modify_time')) {
                                    <th scope="col" class="text-left text-sm font-semibold px-3 py-2 whitespace-nowrap">
                                        Last Modified</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                @for (group of filteredAdGroups(); track group.id) {
                                <tr (click)="focusAdGroup(group)" class="hover:cursor-pointer">
                                    <td
                                        class="sticky left-0 z-10 w-28 min-w-28 max-w-28 bg-[var(--background)] border-r border-[var(--border)] px-3 py-2 align-middle">
                                        <span
                                            [class]="'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ' + sparkOperationStatusClass(group.operationStatus)">
                                            {{ sparkOperationStatusLabel(group.operationStatus) }}
                                        </span>
                                    </td>
                                    <td
                                        class="sticky left-28 z-10 min-w-[12rem] max-w-[20rem] bg-[var(--background)] border-r border-[var(--border)] px-3 py-2 text-sm font-medium text-primary truncate align-middle">
                                        {{
                                        group.adgroupName ?? '—' }}</td>
                                    @if (isVisible('status')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        formatSecondaryOrOperationStatus(group) }}</td>
                                    }
                                    @if (isVisible('time_created')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        formatSparkDate(group.createTime ?? group.createdDate) }}</td>
                                    }
                                    @if (isVisible('budget')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">
                                        <div class="flex flex-col gap-0.5">
                                            <span>{{ formatSparkBudget(group.budget) }}</span>
                                            @if (group.budgetMode) {
                                            <span class="text-xs text-secondary">({{
                                                sparkBudgetModeLabel(group.budgetMode)
                                                }})</span>
                                            }
                                        </div>
                                    </td>
                                    }
                                    @if (isVisible('scheduling')) {
                                    <td class="px-3 py-2 text-sm text-secondary">
                                        <div class="flex flex-col gap-0.5 whitespace-nowrap">
                                            <span><span
                                                    class="text-xs uppercase tracking-wide text-secondary">Start</span>
                                                {{ formatScheduleCell(group).start }}</span>
                                            <span><span
                                                    class="text-xs uppercase tracking-wide text-secondary">End</span>
                                                {{ formatScheduleCell(group).end }}</span>
                                        </div>
                                    </td>
                                    }
                                    @if (isVisible('optimization_goal')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        humanizeApiToken(group.optimizationGoal) }}</td>
                                    }
                                    @if (isVisible('billing_event')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        humanizeApiToken(group.billingEvent) }}</td>
                                    }
                                    @if (isVisible('bid_type')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        humanizeApiToken(group.bidType) }}</td>
                                    }
                                    @if (isVisible('bid_price')) {
                                    <td class="px-3 py-2 text-sm text-right text-primary whitespace-nowrap">{{
                                        group.bidPrice != null ? (group.bidPrice | number:'1.2-4') : '—' }}</td>
                                    }
                                    @if (isVisible('pacing')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        humanizeApiToken(group.pacing) }}</td>
                                    }
                                    @if (isVisible('placements')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        formatStringList(group.placements) }}</td>
                                    }
                                    @if (isVisible('gender')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        humanizeApiToken(group.gender) }}</td>
                                    }
                                    @if (isVisible('age_groups')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        formatStringList(group.ageGroups) }}</td>
                                    }
                                    @if (isVisible('location_ids')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        formatLocationIds(group.locationIds) }}</td>
                                    }
                                    @if (isVisible('languages')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        formatStringList(group.languages) }}</td>
                                    }
                                    @if (isVisible('promotion_type')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        humanizeApiToken(group.promotionType) }}</td>
                                    }
                                    @if (isVisible('feed_type')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        humanizeApiToken(group.feedType) }}</td>
                                    }
                                    @if (isVisible('modify_time')) {
                                    <td class="px-3 py-2 text-sm text-secondary whitespace-nowrap">{{
                                        formatSparkDate(group.modifyTime ?? undefined) }}</td>
                                    }
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>